<template>

    <div :class="['filter-menu', 'filter-' + name ]">

        <div class="filter-label">
            {{ label }}
        </div>

        <div class="flex-grow-1 position-relative">

            <button
                @click.prevent="clickFilter"
                :class="['btn', 'w-100', 'btn-filter', {active: open, disabled: disabled}]"
                :disabled="disabled"
                >{{ display }}</button>

            <filter-dialog v-if="open"  :name="name" :size="sizeClass" :align="align">

                <div class="filter-content filter-single">
                <div class="list-group">
                    <a v-for="opt in options" :key="opt.id"
                        href
                        @click.prevent.stop="apply(name, opt.id)"
                        :class="['list-group-item', 'list-group-item-action', {active: opt == selectedOption}]">
                        {{ opt.name }}
                    </a>
                </div>
                </div>
            </filter-dialog>

        </div>

    </div>

</template>

<script>

import FilterMixin from '@/mls-filter/mixins/FilterMixin.js';
import { startCase } from 'lodash';

export default {

    mixins: [FilterMixin],

    computed: {

        selectedOption() {
            const opt =  this.getOption(this.selected);
            if (opt != null) {
                return opt;
            } else {
                return {
                    id: this.selected,
                    name: this.selected + this.suffix,
                };
            }
        },

        suffix() {
            switch (this.name) {
                case 'size':
                    return ' SQ/FT+';
                default:
                    return '';
            }
        },

        /* Display for single select filter */
        display() {
            if (this.selected) {
                return this.selectedOption.name;
            } else {
                return startCase(this.name);
            }
        },

    },

    methods: {
        apply(filter, option) {
            if (filter === 'sort') {
                this.$store.dispatch('applySort', option);
            } else {
                this.$store.dispatch('applyFilter', {filter, option});
            }
        },
    },
};

</script>